import { memo } from 'react';

export type ContentCollectionSidebarTermsProps = {
  routes: {
    terms: string;
    privacy: string;
  };
};

export const ContentCollectionSidebarTerms = memo(({ routes }: ContentCollectionSidebarTermsProps) => {
  return (
    <p className="mt-auto text-center ads:text-metadata text-12 text-gray-9">
      By using this form, you agree to Air's
      <br />
      <a
        className="ads:text-metadata text-gray-9 underline"
        href={routes.terms}
        rel="noreferrer noopener"
        target="_blank"
      >
        Terms of Service
      </a>{' '}
      and{' '}
      <a
        className="ads:text-metadata text-gray-9 underline"
        href={routes.privacy}
        rel="noreferrer noopener"
        target="_blank"
      >
        Privacy Policy
      </a>
    </p>
  );
});

ContentCollectionSidebarTerms.displayName = 'ContentCollectionSidebarTerms';
